import { FeatureToggle } from "opencak-app";

export class FeatureToggles extends Map<string, FeatureToggle> {
  static of = (featureToggles?: FeatureToggle[]) => new FeatureToggles(featureToggles ?? []);

  private constructor(featureToggles: FeatureToggle[]) {
    super(featureToggles.map(ft => [ft.name, ft]));
  }
  
  isEnabled = (featureName: string) => this.get(featureName)?.enabled ?? false
}